const schLanguageType = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ខ្មែរ' }, { value: 2, text: '២.ចិន' },
  { value: 3, text: '៣.អ៊ីស្លាម' }, { value: 4, text: '៤.បារាំង' }, { value: 5, text: '៥.អង់គ្លេស' },
  { value: 6, text: '៦.វៀតណាម' }, { value: 7, text: '៧.កូរ៉េ' }, { value: 8, text: '៨.ជប៉ុន' },
  { value: 9, text: '៩.ផ្សេងៗ' }
]

const proKas = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' }, { value: 2, text: '២.មានបង្កាន់ដៃបង់ប្រាក់' }, 
  { value: 3, text: '៣.គ្មាន' }
]
const proKasBy = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.រដ្ឋបាលក្រុង/ស្រុក/ខណ្ឌ' }, { value: 2, text: '២.មន្ទីរអយករាជធានី/ខេត្ត' },
  { value: 3, text: '៣.ក្រសួងអយក' }, { value: 4, text: '៤.សាលារាជធានី/ខេត្ត' },
  { value: 5, text: '៥.ក្រសួង/ស្ថាប័នផ្សេងៗ' },
]
const privSchType = [
  { value: 0, text: '០.ជ្រើសរើស' },
  { value: 1, text: '១.មត្តេយ្យសិក្សា' },
  { value: 2, text: '២.បឋមសិក្សា' },
  { value: 3, text: '៣.អនុវិទ្យាល័យ' },
  { value: 4, text: '៤.វិទ្យាល័យ' },
  { value: 5, text: '៥.មត្តេយ្យសិក្សា និងបឋមសិក្សា' },
  { value: 6, text: '៦.មត្តេយ្យសិក្សា និងមធ្យមសិក្សា' },
  { value: 7, text: '៧.បឋមសិក្សា និងមធ្យមសិក្សា' },
  { value: 8, text: '៨.មត្តេយ្យសិក្សា បឋមសិក្សា និងមធ្យមសិក្សា' }
]

const totalGirl = ['សរុប', 'ស្រី']
const maleFemale = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ប្រុស' }, { value: 2, text: '២.ស្រី' }
]
const replacePrinciple = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.នាយករង' }, { value: 2, text: '២.គ្រូបង្រៀន' }
]
const staffType = ['បុគ្គលិកបង្រៀន', 'បុគ្គលិកមិនបង្រៀន']
const location = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.តំបន់ក្រុង' }, { value: 2, text: '២.តំបន់ជនបទ' }
]
const progType = [
  { value: "0", text: '០.ជ្រើសរើស' }, { value: "1", text: '១.ជាតិ' }, { value: "2", text: '២.អន្តរជាតិ' }
]
const yesNo = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ពិតមែន' }, { value: 2, text: '២.ទេ' }
]
const yesNo2 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' }, { value: 2, text: '២.មិនមាន' }
]
const yesNo3 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.អាច' }, { value: 2, text: '២.មិនអាច' }
]
const yesNo4 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.បាទ' }, { value: 2, text: '២.ទេ' }
]
const yesNo5 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.បាន' }, { value: 2, text: '២.មិនបាន' }
]
const yesNo6 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' }, { value: 2, text: '២.គ្មាន' }
]
const condition = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ល្អ' }, { value: 2, text: '២.មធ្យម' },
  { value: 3, text: '៣.អន់' }, { value: 4, text: '៤.មិនទាន់មាន' }
]
const numShift = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មួយវេន' }, { value: 2, text: '២.ពីរវេន' },
  { value: 3, text: '៣.បីវេន' }
]
const inchPos = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.នាយករង' }, { value: 2, text: '២.គ្រូបង្រៀន' }, { value: 3, text: '៣.គ្រូក្រៅក្របខ័ណ្ឌ' }
]
const disable = [
  { text: 'សិស្សពិការ', val: -1 },
  { text: 'ចំនួនសិស្សពិការ*', val: 0 },
  { text: 'ប្រភេទពិការ**', val: -1 },
  { text: '-ពិបាកក្នុងការធ្វើចលនា', val: 1 },
  { text: '-ពិបាកក្នុងការស្ដាប់', val: 2 },
  { text: '-ពិបាកក្នុងការនិយាយ', val: 3 },
  { text: '-ពិបាកក្នុងការមើល', val: 4 },
  { text: '-ពិការសរីរាង្គខាងក្នុង', val: 5 },
  { text: '-ពិការសតិបញ្ញា', val: 6 },
  { text: '-ពិបាកខាងផ្លូវចិត្ត', val: 7 },
  { text: '-ពិការផ្សេងៗ', val: 8 },
  { text: 'សិស្សជួបការលំបាកផ្នែកសុខភាព', val: -1 },
  { text: 'ចំនួនជួបការលំបាកផ្នែកសុខភាព', val: 9 },
  { text: 'ប្រភេទការលំបាកផ្នែកសុខភាព', val: -1 },
  { text: '-ខ្វះអាហារូបត្ថម្ភធ្ងន់ធ្ងរ', val: 10 },
  { text: '-សុខភាព/ជំងឺប្រចាំកាយ', val: 11 },
  { text: 'សិស្សជួបការលំបាក', val: -1 },
  { text: 'ចំនួនសិស្សជួបការលំបាក', val: 12 },
  { text: 'ប្រភេទការលំបាក', val: -1 },
  { text: '-មកពីគ្រួសារផ្លាស់ប្ដូរទីលំនៅ', val: 13 },
  { text: '-កុមារកំព្រា', val: 14 },
  { text: '-កុមាររងគ្រោះដោយ HIV/AIDS', val: 15 },
  { text: '-កុមាររងអំពើហិង្សាក្នុងគ្រួសារ', val: 16 },
  { text: '-កុមាររងការកេងប្រវ័ញ្ចពលកម្ម', val: 17 },
  { text: '-កុមារដែលមកពីគ្រួសារក្រីក្រ', val: 18 }
]
const roomEnv = ['សរុប', 'មានអគ្គីសនី', 'មានអំពូល', 'មានកង្ហារ/ម៉ាស៊ីនត្រជាក់']

const d1 = ['< ២០', '២០-២៤', '២៥-២៩', '៣០-៣៩', '៤០-៤៩', '៥០-៥៤', '៥៥', '៥៦', '៥៧', '៥៨', '≥៥៩']
const d2 = ['< ៥', '៥-៩', '១០-១៤', '១៥-១៩', '២០-២៤', '២៥-២៩', '≥ ៣០']

const d3 = ['ក្នុងបឋមសិក្សា', 'វិញ្ញាបនបត្របឋមសិក្សា', 'ក្នុងមធ្យមសិក្សាបឋមភូមិ', 'សញ្ញាបត្រមធ្យមសិក្សាបឋមភូមិ', 'ក្នុងមធ្យមសិក្សាទុតិយភូមិ',
  'សញ្ញាបត្រមធ្យមសិក្សាទុតិយភូមិ', 'ក្នុងមហាវិទ្យាល័យ', 'បរិញ្ញាបត្រ', 'បរិញ្ញាបត្រជាន់ខ្ពស់ (អនុបណ្ឌិត)', 'សញ្ញាបត្របណ្ឌិត']

const b4 = [
  'លេខាធិការ',
  'បណ្ណារក្ស',
  'គ្រូទទួលបន្ទុកកីឡា',
  'គ្រូទទួលបន្ទុកបច្ចេកវិទ្យាព័ត៌មានវិទ្យា ICT',
  'គ្រូទទួលបន្ទុកគណនេយ្យ និងបេឡា',
  'គ្រូទទួលបន្ទុកបន្ទប់ពិសោធន៍',
  'គ្រូទទួលបន្ទុកការងារសុខភាពសិក្សា',
  'គ្រូទទួលបន្ទុកកិច្ចការពារកុមារ'
]

const d4 = ['ចំនួនម៉ោងបង្រៀនសរុបជាភាសាខ្មែរក្នុង១សប្តាហ៍', 'ចំនួនម៉ោងបង្រៀនសរុបជាភាសាបរទេសក្នុង១សប្តាហ៍']

const d5 = [
  '*បុគ្គលិកនៅមត្តេយ្យសិក្សា',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិករដ្ឋមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកបរទេសមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកមានពិការភាពមាន',
  '*បុគ្គលិកនៅបឋមសិក្សា',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិករដ្ឋមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកបរទេសមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកមានពិការភាពមាន',
  '*បុគ្គលិកនៅមធ្យមសិក្សាបឋមភូមិ',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិករដ្ឋមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកបរទេសមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកមានពិការភាពមាន',
  '*បុគ្គលិកនៅមធ្យមសិក្សាទុតិយភូមិ',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិករដ្ឋមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកបរទេសមាន',
  '&nbsp;&nbsp;&nbsp;ក្នុងនោះបុគ្គលិកមានពិការភាពមាន'
]

const e1 = [' -ផ្ទៃដីសរុបជារបស់សាលារៀន(កម្មសិទ្ធិ / ជួល)', '-ទីធ្លាសាលារៀន(សម្រាប់រត់លេង និងកីឡា)',
  '-ផ្ទៃក្រឡាបន្ទប់រៀនទាំងអស់(មិនគិតផ្ទៃរានហាល)']
const e11 = ['ផ្ទៃដីសរុបជាកម្មសិទិ្ធរបស់មត្តេយ្យសិក្សាសហគមន៍', '-ទីធ្លាសាលារៀន(សម្រាប់រត់លេង និងកីឡា)', '-ផ្ទៃក្រឡាបន្ទប់រៀន', '-ផ្ទៃដីនៅសល់សម្រាប់សាងសង់', '-ផ្ទៃក្រលាសួនកសិកម្ម(ជីវចម្រុះ)']
const e12 = ['-ផ្ទៃដីសរុបជារបស់សាលារៀន(កម្មសិទ្ធិ)', '-ផ្ទៃដីសរុបរបស់សាលា (ជួល)', '-ទីធ្លាសាលារៀន(សម្រាប់រត់លេង និងកីឡា)', '-ផ្ទៃក្រឡាបន្ទប់រៀនទាំងអស់(មិនគិតផ្ទៃរានហាល)', '-ផ្ទៃក្រឡាសួនកសិកម្ម(ជីវចម្រុះ)']
const e13 = ['តុសិស្សអង្គុយម្នាក់ៗ', 'តុសិស្សអង្គុយពីរនាក់', 'កៅអី/កៅអីវែងសម្រាប់សិស្សអង្គុយច្រើននាក់', 'តុសម្រាប់គ្រូ', 'ក្ដារខៀន']
const e2 = ['ធ្វើអំពីឥដ្ឋ / ស៊ីម៉ង់ (ថ្ម)', 'ធ្វើអំពីឈើ (ឈើ/ដែក)']
const building = ['អគារជួសជុលថ្មី', 'អគារសាងសង់ថ្មី', 'អគារគ្មានកម្រាលល្អ', 'អគារគ្មានដំបូលល្អ', 'អគារគ្មានជញ្ជាំងល្អ/បង្អួចល្អ/ទ្វារល្អ',
  'តុសិស្ស', 'កៅអី/កៅអីវែងសម្រាប់សិស្ស', 'កៅអីសម្រាប់គ្រូ', 'តុសម្រាប់គ្រូ', 'ក្ដារខៀន']
const roomCond = ['ទីចាត់ការ', 'បណ្ណាល័យ', 'បន្ទប់អប់រំបំណិនជីវិត', 'មជ្ឈមមណ្ឌលធនធាន', 'ឃ្លាំងដាក់សម្ភារៈ', 'បន្ទប់កុំព្យូទ័រ',
  'បន្ទប់ថែទាំសុខភាព', 'អាហារដ្ឋាន', 'បន្ទប់ផ្សេងទៀត', 'ទីជម្រាល​សម្រាប់​កុមារ/គ្រូ​ពិការ']
const handWashing = ['កន្លែងលាងសម្អាតដៃ (អាចប្រើបានបន្ទាប់ពីប្រើបង្គន់)', 'កន្លែងលាងសម្អាតដៃ', 'ការគ្រប់គ្រងអនាម័យពេលមានរដូវ']
const handWashingPrio = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន (សម្រាប់លាងម្នាក់ឯង)' },
  { value: 2, text: '២.មាន (សម្រាប់លាងជាក្រុម)' }, { value: 3, text: '៣.មាន (ទាំងសម្រាប់ម្នាក់ឯង និងសម្រាប់ជាក្រុម)' },
  { value: 4, text: '៤.មិនមាន' }
]
const handWashingPrio2 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' },
  { value: 2, text: '២.មានខ្លះ' }, { value: 3, text: '៣.មិនមាន' }
]
const handWashingCond = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មានសាប៊ូនិងទឹកថ្ងៃនេះ' },
  { value: 2, text: '២.មានតែទឹកថ្ងៃនេះ' }, { value: 3, text: '៣. គ្មានសាប៊ូឬទឹកទេថ្ងៃនេះ' }
]
const handWashingCond2 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មានសំឡីអនាម័យពេលត្រូវការបន្ទាន់' },
  { value: 2, text: '២.មានធុងសំរាមនៅបង្គន់ស្រ្តី' }, { value: 3, text: '៣.មានកន្លែងលាងសម្អាតនៅបង្គន់ស្រ្តី' }
]
const toiletRow = ['ចំនួនបង្គន់អនាម័យចាក់ទឹក/ចុចបង្ហូរទឹក', 'ចំនួនបង្គន់អនាម័យចាក់ទឹក/ចុច បង្ហូរទឹកដែលអាចប្រើបាន មានទឹក',
  'ចំនួនបង្គន់អនាម័យផ្សេងទៀត', 'ចំនួនកន្លែងនោមសិស្សប្រុស']
const water = ['បណ្តាញទុយោ', 'អណ្តូងស្នប់/អណ្តូងខួង', 'អណ្តូងជីក/ទឹកផុសចេញពីក្រោមមានការការពារ', 'ទឹកភ្លៀង',
  'ទឹកពិសាដប', 'ទឹកទិញដឹកដោយទ្បានស៊ីទែន/រទេះរុញ', 'អណ្តូងជីក/ទឹកផុសចេញពីក្រោមមិនមានការការពារ', 'ទឹកបឹង/ស្រះ/ទន្លេ/ព្រែក/អូរ/ស្ទឹង']
const facility = ['បណ្ដាញអគ្គិសនី', 'ថាមពលប្រើពន្លឺព្រះអាទិត្យ', 'ម៉ាស៊ីនភ្លើង', 'អគ្គិសនីសម្រាប់ការិយាល័យ']
const facility2 = ['កុំព្យូទ័រសរុប', 'កុំព្យូទ័រប្រើប្រាស់បាន', 'កុំព្យូទ័រសម្រាប់ការិយាល័យ', 'កុំព្យូទ័រសម្រាប់ការបង្រៀន និងរៀន',
  'ម៉ាស៊ីនបោះពុម្ព', 'ម៉ាស៊ីនថតចម្លង', 'ម៉ាស៊ីន Scanner', 'ម៉ាស៊ីនដេរ',
  'ម៉ាស៊ីនបញ្ចាំង LCD', 'ផ្ទាំងក្រណាត់បញ្ចាំងស្លាយ', 'ប្រអប់សង្គ្រោះបឋម និងសម្ភារៈបម្រុង', 'ខ្សែរបណ្ដាញ Internet']
const elecType = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.រដ្ឋ' }, { value: 2, text: '២.ឯកជន' },
  { value: 3, text: '៣.រដ្ឋ និងឯកជន' }, { value: 4, text: '៤.គ្មាន' }
]
const sportType = ['ទីធ្លា', 'សម្ភារ', 'ក្រុមកីឡា']
const sportUtil = ['បាល់ទះ', 'បាល់ទាត់', 'បាល់បោះ', 'ឡើងខ្សែពួរ']
const sportUtil2 = ['ចោលដុំដែក', 'លោតកម្ពស់', 'លោតចម្ងាយ', 'រត់ចម្ងាយ']
const financial = ['ថវិកាកម្មវិធី PB ដែលបានទទួល (សម្រាប់ដំណើរការសាលារៀន)-', 'ថវិការដ្ឋាភិបាលសម្រាប់សាងសង់-',
  'សរុបចំណូលផលិតកម្មរបស់សាលារៀន', 'អំណោយពីសហគមន៍/សប្បុរសជនក្នុងប្រទេស', 'អំណោយសប្បុរសជនក្រៅប្រទេស',
  'អំណោយពីអង្គការអន្តរជាតិ និងអង្គការមិនមែនរដ្ឋាភិបាល', 'បុណ្យផ្សេងៗ']

const e11OnOff = [
  [0, 0, 1], [0, 0, 1], [0, 0, 1], [1, 1, 1], [0, 0, 1]
]
/* Configuration ON-OFF cells */
const toiletOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 1, 0, 0, 0, 1]
]
const buildingOnOff = [
  [1, 1], [1, 1], [1, 1], [1, 1], [1, 1],
  [1, 0], [1, 0], [1, 0], [1, 0], [1, 0]
]
const degree = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ក្នុងបឋមសិក្សា' }, { value: 2, text: '២.វិញ្ញាបនប័ត្របឋមសិក្សា' },
  { value: 3, text: '៣.ក្នុងមធ្យមសិក្សាបឋមភូមិ' }, { value: 4, text: '៤.សញ្ញាប័ត្រមធ្យមសិក្សាបឋមភូមិ' }, { value: 5, text: '៥.ក្នុងមធ្យមសិក្សាទុតិយភូមិ' },
  { value: 6, text: '៦.សញ្ញាប័ត្រមធ្យមសិក្សាទុតិយភូមិ' }, { value: 7, text: '៧.ក្នុងមហាវិទ្យាល័យ' }, { value: 8, text: '៨.បរិញ្ញាប័ត្រ' },
  { value: 9, text: '៩.បរិញ្ញាប័ត្រជាន់ខ្ពស់ (អនុបណ្ឌិត)' }, { value: 10, text: '១០.សញ្ញាប័ត្របណ្ឌិត' }
]
const comDesc = [
  'ចំនួនគណៈកម្មការគ្រប់គ្រងសាលារៀន',
  'សហគមន៍បានចូលរួមជួយគាំទ្រ មូលនិធិដំណើរការសាលារៀន',
  'ចំនួននាយក នាយករងបានទទួលការហ្វឹកហាត់កម្មវិធីគ្រប់គ្រងសាលារៀនគំរូ',
  'សាលារៀនបានទទួលការចុះពិនិត្យតាមដាន និងផ្តល់ការគាំទ្រ ពីថ្នាក់ជាតិ',
  'សាលារៀនបានទទួលការចុះពិនិត្យតាមដាន និងផ្តល់ការគាំទ្រពីថ្នាក់ក្រោមជាតិ'
]
export {
  schLanguageType, proKas, proKasBy,
  inchPos, privSchType,
  totalGirl, maleFemale, staffType, location, progType, yesNo, yesNo2, yesNo3, yesNo4, yesNo5, yesNo6, condition,
  numShift, disable, roomEnv, d1, d2, d3, d4, d5, e1, e11, e12, e13, e2, b4, building, roomCond,
  handWashing, handWashingCond, handWashingCond2, handWashingPrio, handWashingPrio2,
  toiletRow, water, facility, facility2, elecType, sportType, sportUtil, sportUtil2,
  financial,
  e11OnOff, toiletOnOff, buildingOnOff, replacePrinciple, degree, comDesc
}
